<div class="row head-top mx-0 my-3">
    <div class="col-md-5">
        <div class="row m-0">
            <h5 class="primary-text font-weight-bold sm-22 LightGreen my-3">Your request has been sent!</h5>
            <small class="sm-12 secondary-text">Your request to <span class="sm-12 primary-text">{{requestMoneyervice.step1Data.name}}</span> is in progress. We'll update you when it's complete - but you can track the progress of your transaction from the home tab.</small>
        </div>
        <div class="row m-0">
            <button [routerLink]="['/dashboard']" routerLinkActive="router-link-active"  class="btn primary-btn w-50 h-auto mt-3">Return home</button>
        </div>
    </div>
</div>